import type { TransferGalleryComponent } from "@motain/xpa-proto-files-web/lib/types/transfer_gallery";
import type { FC } from "react";
import { useMemo } from "react";
import { TransferCard } from "@/xpa-components/transfer-card/transfer-card/TransferCard";
import classNames from "classnames";
import styles from "./TransferGallery.module.scss";
import { HorizontalScrollingContainer } from "@/components/horizontal-scrolling-container/HorizontalScrollingContainer";
export const TransferGallery: FC<TransferGalleryComponent> = (props) => {
  const { title, transferCards } = props;

  const listTransfer = useMemo(
    () =>
      transferCards.map((card) => ({
        element: <TransferCard {...card} />,
        key: card.uiKey,
      })),
    [transferCards],
  );

  return (
    <div>
      <p className={classNames("title-7-bold", styles.title)}>{title}</p>
      <HorizontalScrollingContainer items={listTransfer} />
    </div>
  );
};
